'use client';

import { Button } from '@/components/ui/button';
import { SUGGESTED_LANGUAGE } from '@/constants';
import { Cross1Icon } from '@radix-ui/react-icons';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';

function getCookie(name) {
  // Check if document.cookie is available (client-side only)
  if (typeof document === 'undefined') {
    console.warn('document.cookie is not available (running on server side).');
    return null;
  }

  // Split all cookies into an array of key-value pairs
  const cookies = document.cookie.split(/;\s*/);

  // Loop through the cookies to find the one with the specified name
  for (let cookie of cookies) {
    // Trim any leading or trailing whitespace
    const [cookieName, cookieValue] = cookie.trim().split('=');

    // If the cookie name matches, return its value
    if (cookieName === name) {
      return decodeURIComponent(cookieValue); // Decode the value if it's encoded
    }
  }
  return null;
}

export default function SuggestedLanguageAlert({ data = {} }) {
  const { title, clickHereLabel, toContinueLabel } = data;
  const [lang, setLang] = useState('');
  const { locale } = useParams();

  useEffect(() => {
    const lang = getCookie(SUGGESTED_LANGUAGE);
    const hideSuggestAlert = window.localStorage.getItem('hideSuggestAlert');
    if (lang && !hideSuggestAlert) setLang(lang);
  }, []);

  if (!lang || lang === locale) return <></>;

  return (
    <div className='relaitve flex items-center justify-center flex-wrap gap-x-1.5 bg-gray-600 pl-4 pr-9 py-2 w-full text-center text-balance text-white link-primary'>
      <span>{title}</span>
      <Link href={`/${lang}`}>{clickHereLabel}</Link>
      <Button
        variant='ghost'
        size='icon'
        className='hover:bg-white/5 hover:text-white absolute top-0 right-0'
        onClick={() => {
          window.localStorage.setItem('hideSuggestAlert', 'true');
          setLang('');
        }}
      >
        <Cross1Icon />
      </Button>
      <span>{toContinueLabel}</span>
    </div>
  );
}
